import { takeEvery } from 'redux-saga'
import { put, call, all } from 'redux-saga/effects'
import { SIGN_IN } from 'actions/applicationActionTypes'
import getLegacyProjectsSaga from 'sagas/getLegacyProjectsSaga'
import configDatabase from 'sagas/setupProjectsSaga/configDatabase'
import ensureAppIntegrity from 'sagas/setupProjectsSaga/ensureAppIntegrity'
import deferApplyProjects from 'sagas/setupProjectsSaga/deferApplyProjects'
import { notifyHoneybadgerAction, showMobileErrorAction,
  storeOfflineAction, storeActiveAction } from 'actions/applicationActions'
import { notificationAction } from 'actions/notificationActions'

export function * signIn(action) {
  try {
    const { active } = action

    yield put(storeOfflineAction(!active))
    yield put(storeActiveAction(active))
    yield put(notificationAction('Signed in successfully', 'none'))

    if (active) {
      const db = yield call(configDatabase)
      yield call(ensureAppIntegrity, db)

      yield all([
        call(deferApplyProjects, -1),
        call(getLegacyProjectsSaga)
      ])
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: SIGN_IN, skipThrow: true }))
    yield put(showMobileErrorAction())
  }
}

export function * watchSignIn() {
  yield * takeEvery(SIGN_IN, signIn)
}



// WEBPACK FOOTER //
// ./src/sagas/signInSaga.js